import React from "react";
import BasePopup from "../Popup/index";
import bgPopupCongratu from "../../../../../assets/images/Event-2026/back-change-coin.png";
import bgTitle from "../../../../../assets/images/Event-2026/congrat.png";
import bgTitleTBN from "../../../../../assets/images/Event-2026/congrats-ribbonTBN.png";
import styled from "styled-components";
import bgButton from "../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import { setOpenPopupIntroGift } from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../../config/PATH";
import {
  ID_HIDDEN_POPUP_INTRO_GIFT,
  ID_TAB_MINI_GAME,
} from "../../../../../helper/const";
import { Trans, useTranslation } from "react-i18next";
import _ from "lodash";
import { getItemCookie, setCookieExpireEndOfDay } from "../../../../../utils/cookie";
import moment from "moment";
import { handleGetDataTakePrizeMinigame } from "../../../../../helper/helper";

export default function PopupIntroGift({ isShow = true, className, dataAward, setDataAward }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dataAwardListMini, popupIntroGift } = useSelector(curStateMiniGame);

  const onCancel = () => {
    if (typeof (setDataAward) === "function") {
      setDataAward(false)
    }
    if (popupIntroGift?.isSetCookie) {
      let listId = [];
      if (getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT)) {
        listId = getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT)
      }
      const now = moment(); // thời gian hiện tại
      const formatted = now.format('YYYY-MM-DDTHH:mm:ss');
      const data = {
        timeShowPopup: formatted,
        idTakePrize: dataTakePrize.id
      }
      listId = [...listId, data]

      setCookieExpireEndOfDay(ID_HIDDEN_POPUP_INTRO_GIFT, JSON.stringify(listId));
    }

    dispatch(
      setOpenPopupIntroGift({
        isShow: false,
        isSetCookie: false,
      })
    );
  };

  let dataTakePrize = handleGetDataTakePrizeMinigame(dataAwardListMini);
  if (dataAward) {
    dataTakePrize = {
      ...dataAward,
      image: dataAward?.obj_puzzle_piece?.award_image,
      id: dataAward?.obj_puzzle_piece?.id

    }
  }

  if (_.isEmpty(dataTakePrize)) {
    return null;
  }
  const handleClick = () => {
    onCancel();
    navigate(
      `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${dataTakePrize?.id}`)
  }

  return (
    <BasePopup
      BasePopup
      open={true}
      className={className}
      onCancel={onCancel}
      closable={true}
      getContainer
    >
      <Container className="popup-cong-mini">
        <div className="popup-cong-mini-main">
          <div className="container-popup-cong-mini-main">
            <img src={i18n.language === 'en' ? bgTitle : bgTitleTBN} alt="title" />
            <div className="content-main">
              {/* {t("You've successfully completed the puzzle and earned 2026 FIFA Trophy Lego now!")} */}
              <Trans
                i18nKey="you_ve_successfully_completed_the_puzzle_and_earned_now"
                values={{
                  name: dataTakePrize?.name || "",
                }}
                components={{
                  highlight: <span className="content_highlight" />,
                }}
              />
            </div>
            <div className="img-prize">
              <img src={dataTakePrize?.image} alt="" />
            </div>
            {/* <div className="content-coins">{dataTakePrize?.name}</div> */}
            <div className="content-footer">
              {/* <Trans
                i18nKey="bitel_will_contact_you_soon_after_the_events_end_to_arrange_your_reward"
                components={{ br: <br /> }}
              /> */}
              <button className='btn' onClick={handleClick}>
                {t('take_prize')}
              </button>
            </div>
          </div>
        </div>
      </Container>
    </BasePopup>
  );
}

const Container = styled.div`
.popup-cong-mini-main{
    background-image: url(${bgPopupCongratu});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    .container-popup-cong-mini-main{
      padding: 70px 20px 20px 20px;
      text-align: center;

    }

    .content-main{
      color: #fff;
      font-size: 17px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
      width: 100%;
      padding: 20px 40px;
       @media (min-width: 768px){
      padding: 10px 20px;
    }
    }
    .content_highlight{
      color: #fff;
      font-size: 17px;
      font-weight: 600;
      line-height: 26px;
    }
    .img-prize{
      padding: 40px 0;
    }
    .content-coins{
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      padding: 40px 0;
    }
   
    .content-footer{
       color: #fff;
      font-size: 14px;
      font-weight: 600;
      font-style: italic;
      text-shadow:
    -1px -1px 0 rgba(1, 63, 151, 1),
     1px -1px 0 rgba(1, 63, 151, 1),
    -1px  1px 0 rgba(1, 63, 151, 1),
     1px  1px 0 rgba(1, 63, 151, 1),
    }
    .btn{
      max-width: 270px;
      width: 100%;
      border: none;
      outline: none;
      color: #fff;
      font-weight: 600;
      font-size: 16px;
      padding: 10px 20px;
      border-radius: 8px;
      background: linear-gradient(
        180deg,
        #1ea317 0%,
        #19b810 100%
      );
    }
}
 
`;
